// Mock data for the WOW Nautic link tree page

export const profileData = {
  name: "@wownautic",
  bio: "Wow Nautic, the number 1 of the Costa del Sol !",
  avatar: "/images/logo-wownautic.webp",
};

export const linksData = [
  {
    id: 1,
    title: "BOOKING WHATSAPP",
    url: "http://wa.me/34683171717",
    icon: "whatsapp",
    thumbnail: "/images/icon-whatsapp.png",
    thumbnailFit: "contain",
  },
  {
    id: 2,
    title: "WEBSITE FOR INFORMATION",
    url: "https://wownautic.com",
    icon: "globe",
    thumbnail: "/images/icon-website.png",
    thumbnailFit: "contain",
  },
  {
    id: 3,
    title: "LEAVE ME A 5 STAR GOOGLE REVIEW",
    url: "https://www.google.com/maps/place//data=!4m3!3m2!1s0xd72e35ca9578b3b:0xa10da4ec09350bc6!12e1",
    icon: "star",
    thumbnail: "/images/icon-google.png",
    thumbnailFit: "contain",
  },
  {
    id: 4,
    title: "FOLLOW US ON INSTAGRAM",
    url: "https://www.instagram.com/wow_nautic/",
    icon: "instagram",
    thumbnail: "/images/icon-instagram.png",
    thumbnailFit: "contain",
  },
  {
    id: 5,
    title: "FOLLOW US ON FACEBOOK",
    url: "https://www.facebook.com/p/WOW-Nautic-Boat-and-Jet-Ski-Rentals-61576095742020/",
    icon: "facebook",
    thumbnail: "/images/icon-facebook.svg",
    thumbnailFit: "contain",
  },
  {
    id: 6,
    title: "FOLLOW US ON TIKTOK",
    url: "https://www.tiktok.com/@wownautic.com?_r=1&_t=ZN-95WZGs3IKYg",
    icon: "tiktok",
    thumbnail: "/images/tiktok-logo.png",
    thumbnailFit: "contain",
  },
];

/** YouTube background: plays [startSeconds, endSeconds] on loop (see LinkTreePage + IFrame API). */
export const videoBackground = {
  videoId: "M6RB1nWXC8o",
  startSeconds: 35,
  endSeconds: 70,
};
